import { createAction, props } from '@ngrx/store';
import { ICobertsObjectsData } from '../contracts/contracts.models';
import { ICoverage } from './coverages.models';
 
export const setCoverages = createAction(
    '[Coverages] Set Coverages',
    props<{ coverages: ICoverage[] }>()
);

export const updateCoverageStatus = createAction(
    '[Coverages] Update coverage status',
    props<{ id: number, status: { seleccionada: boolean, activada: boolean }}>()
)